<template lang="pug">
div(v-if="preview" style="height: 450px; width: 100%;")
  label.form-label Preview
  PDFViewer(style="height: 450px; width: 100%;" :source="preview" :controls="['catalog', 'switchPage']")
</template>

<script>
import pdfService from '@/services/pdf'
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'

export default {
  props: {
    pages: { type: [Number, String] },
    initialPage: { type: [Number, String] },
    file: { type: File },
  },
  components: { PDFViewer },
  data() {
    return {
      preview: null,
    }
  },
  watch: {
    pages() {
      this.reloadPreview()
    },
    initialPage() {
      this.reloadPreview()
    },
    file() {
      this.reloadPreview()
    },
  },
  methods: {
    async reloadPreview() {
      if (this.file && Number(this.initialPage) && Number(this.pages)) {
        const pdfPreview = await pdfService.extractPagesFromPdf(
          this.file,
          Number(this.initialPage),
          Number(this.pages),
        )
        var reader = new FileReader()
        reader.readAsDataURL(pdfPreview)
        reader.onload = () => {
          console.log('reader', reader.result)
          this.preview = reader.result
        }
        reader.onerror = error => {
          console.log('Error: ', error)
        }
      }
    },
  },
}
</script>
